import type { ReactNode } from 'react';
import './AuthLayout.css';

interface Props {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Card max-width in px — default 512 per auth design spec. Form 2 cột (đăng ký) truyền 640. */
  width?: number;
  /** Custom logo/avatar element for header — defaults to gray circle placeholder per design mockup */
  avatar?: ReactNode;
}

export function AuthLayout({ title, subtitle, children, footer, width = 512, avatar }: Props) {
  return (
    <div className="auth-container">
      <div
        className="auth-card"
        style={{ '--auth-modal-width': `${width}px` } as React.CSSProperties}
      >
        <div className="auth-avatar-wrapper">
          {avatar ?? <div className="auth-avatar" />}
        </div>
        <div className="auth-header">
          <h1 className="auth-title">{title}</h1>
          {subtitle && <div className="auth-subtitle">{subtitle}</div>}
        </div>
        {children}
        {footer && <div className="auth-footer">{footer}</div>}
      </div>
    </div>
  );
}
